export default __webpack_public_path__ + "media/images/fancybox/fancy_nav_right-c2687fb60ddf9f412ed57dd496ff61fe.png";